/** @format */

import React, { useState } from "react";

const List = () => {
  const [filter, setfilter] = useState("");
  const data = list.filter((e) =>
    filter !== "" ? e.tags.includes(filter) : list
  );
  return (
    <>
      <ul className='grid gap-2 grid-cols-2 lg:grid-cols-3 p-2'>
        <li
          className={
            filter === ""
              ? "active-filter text-center place-content-center grid"
              : "text-center place-content-center grid text-white"
          }
          onClick={() => setfilter("")}>
          all
        </li>
        {tagsList.map((e) => (
          <li
            onClick={() => setfilter(e)}
            key={e}
            className={
              filter === e
                ? "active-filter text-center place-content-center grid"
                : "text-center place-content-center grid text-white"
            }>
            {e}
          </li>
        ))}
      </ul>


      <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-3 p-3'>
        {data.map(({ title, img, description, url, repo, tags }) => {
          return (
            <div
              className='card overflow-hidden transition-transform ease-in-out duration-3 bg-black h-[190px]'
              key={title}>
              <div
                key={title}
                href={url}
                className='w-full grid 
            overflow-hidden h-[190px]'>
                <img src={img} alt={title} className='h-full w-fit' />
              </div>
              <div className='backdrop-blur-md p-3 h-[190px] bg-black/30 hide grid'>
                <div className='flex justify-between'>
                  <a href={repo} target='_blank' rel='noreferrer'>
                    <span className='border-b'>code</span>
                  </a>
                  <a
                    className='px-3 py-1'
                    href={url}
                    target='_blank'
                    rel='noreferrer'>
                    <span className='border-b'>page</span>
                  </a>
                </div>
                <div className='flex gap-1 text-xs flex-wrap'>
                  {tags.map((e, index) => (
                    <span key={index + e}>{e}</span>
                  ))}
                </div>
                <h3 className='text-xl'>{title}</h3>
                <p className=''>{description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default List;

const list = [
  {
    title: "Events Planner",
    repo: "https://github.com/OmniaCrystalline/events",
    url: "https://radiant-unicorn-2d9412.netlify.app/",
    img: "./images/events.png",
    tags: ["react", "html", "css", "redux"],

    description:
      "Personal notepad, helps to plan events, sort for relevance and time",
  },
  {
    title: "FinanceLedger",
    repo: "https://github.com/OmniaCrystalline/FinanceLedger",
    url: "https://majestic-belekoy-1d69f4.netlify.app",
    img: "./images/finance.png",
    tags: ["react", "html", "sass"],
    description: "Finance ledger landing",
  },
  {
    title: "Lawyer",
    url: "https://lawyer-justice.vercel.app/",
    repo: "https://github.com/OmniaCrystalline/lawer-next",
    img: "./images/law.png",
    tags: ["NextJS"],
    description: "Personal lawyer`s page",
  },
  {
    title: "Administrator",
    url: "https://ersag-edit.web.app/add",
    repo: "https://github.com/OmniaCrystalline/work-space",
    img: "./images/admin.png",
    tags: ["react", "html", "css", "mongoDB"],
    description:
      "Manager`s page for processing purchase orders and editing products on the site",
  },
  {
    title: "Delivery",
    url: "https://delivery-lucky.netlify.app/",
    repo: "https://github.com/OmniaCrystalline/shop-front-test",
    img: "./images/pizza.png",
    tags: ["react", "html", "Tailwind", "mongoDB"],
    description: "Delivery service",
  },
  {
    title: "Calculator",
    url: "https://calculator-43d6e.web.app/",
    repo: "https://github.com/OmniaCrystalline/calculator",
    img: "./images/calculator.png",
    tags: ["react", "html", "JavaScript"],
    description: "JS calculator based on React",
  },
  {
    title: "Ersag",
    url: "https://ersag-front.web.app/products",
    repo: "https://github.com/OmniaCrystalline/ersag-front",
    img: "./images/ersag.png",
    tags: ["react", "css", "redux"],
    description: "Shop based on React, Redux, pure css, minimal decoration",
  },
  {
    title: "Ersag Next",
    url: "https://ersag-next-client.vercel.app/",
    repo: "https://github.com/OmniaCrystalline/ersag-next-client",
    img: "./images/ersag-next.png",
    tags: ["NextJS", "css", "redux"],
    description: "Shop based on NextJS, app directory, client components",
  },
  {
    title: "Movies",
    url: "https://stirring-sable-fbfb57.netlify.app/",
    repo: "https://github.com/OmniaCrystalline/movie",
    img: "./images/movies.png",
    tags: ["React", "REST API", "styled-components"],
    description: "Movie search app based on themoviedb",
  },
  {
    title: "25+5 clock",
    url: "https://musical-otter-4652f2.netlify.app/",
    repo: "https://github.com/OmniaCrystalline/clock",
    img: "./images/clock.png",
    tags: ["React", "Tailwind"],
    description:
      "App based on React with possibility to set timer and period of pause with alert",
  },
  {
    title: "Silverexpress",
    repo: "Wordpress",
    url: "https://silverexpress.online",
    img: "./images/silver.png",
    tags: ["wordpress"],
    description: "Silver jewellery shop",
  },
  {
    title: "First Blog",
    repo: "https://github.com/OmniaCrystalline/1",
    url: "https://blog-ts-wine.vercel.app",
    img: "./images/blog.png",
    tags: [
      "NextJS",
      "google/github auth",
      "responsive",
      "mongoDB",
      "Cloudinary",
      "Tailwind",
    ],
    description: "Ability for registered user to create posts, comments",
  },
];

export const tagsList = [
  ...new Set(Object.values(list.map((e) => e.tags)).flat()),
];
